/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { StaticPageDetail } from './StaticPageDetail'
import {
  StaticPageDetailFromJSON,
  StaticPageDetailFromJSONTyped,
  StaticPageDetailToJSON,
} from './StaticPageDetail'

/**
 *
 * @export
 * @interface EnvelopedStaticPageStaticPageDetail
 */
export interface EnvelopedStaticPageStaticPageDetail {
  /**
   *
   * @type {StaticPageDetail}
   * @memberof EnvelopedStaticPageStaticPageDetail
   */
  body: StaticPageDetail
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedStaticPageStaticPageDetail
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedStaticPageStaticPageDetail interface.
 */
export function instanceOfEnvelopedStaticPageStaticPageDetail(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedStaticPageStaticPageDetailFromJSON(
  json: any,
): EnvelopedStaticPageStaticPageDetail {
  return EnvelopedStaticPageStaticPageDetailFromJSONTyped(json, false)
}

export function EnvelopedStaticPageStaticPageDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedStaticPageStaticPageDetail {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: StaticPageDetailFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedStaticPageStaticPageDetailToJSON(
  value?: EnvelopedStaticPageStaticPageDetail | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: StaticPageDetailToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
